"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconClockFast = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconClockFast = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "48",
    height: "40",
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M27.7615 5.6995C27.0205 5.6995 26.4216 6.29842 26.4216 7.03945V20.0032C26.4216 20.4069 26.6035 20.7898 26.9181 21.0437L32.6948 25.7288C32.9431 25.9297 33.2406 26.0283 33.5363 26.0283C33.9248 26.0283 34.3134 25.8596 34.5768 25.5317C35.043 24.9574 34.9539 24.114 34.3797 23.6478L29.0974 19.3664L29.0993 7.03969C29.0993 6.29866 28.5004 5.69974 27.7613 5.69974L27.7615 5.6995Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M19.8015 29.205C20.5406 29.205 21.1415 28.6061 21.1415 27.8651C21.1415 27.124 20.5425 26.5251 19.8015 26.5251H10.9356C10.1946 26.5251 9.59569 27.124 9.59569 27.8651C9.59569 28.6042 10.1946 29.205 10.9356 29.205H19.8015Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M1.33961 20.6986H7.78536C7.80999 21.3923 7.85738 22.0822 7.95024 22.755C8.045 23.4241 8.61738 23.9092 9.27505 23.9092C9.3357 23.9092 9.39825 23.9055 9.46079 23.8979C10.1942 23.7955 10.706 23.1189 10.6018 22.3854C10.5241 21.8339 10.4843 21.2672 10.4615 20.6986H16.21C16.9511 20.6986 17.55 20.0997 17.55 19.3587C17.55 18.6176 16.9511 18.0187 16.21 18.0187H1.33995C0.60081 18.0187 0 18.6176 0 19.3587C0 20.0978 0.598918 20.6986 1.33995 20.6986L1.33961 20.6986Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.26281 12.0943H9.44L8.79373 13.4437C8.47532 14.1109 8.75771 14.9106 9.42486 15.2291C9.61059 15.3182 9.8077 15.3598 10.001 15.3598C10.5013 15.3598 10.9809 15.0793 11.2102 14.598L12.3113 12.2933C12.3587 12.1948 12.3891 12.0924 12.4099 11.9901C15.412 6.23959 21.2549 2.68024 27.7598 2.68024C37.3084 2.68024 45.0787 10.451 45.0787 20.001C45.0787 29.5515 37.3098 37.3199 27.7598 37.3199C23.0141 37.3199 18.5868 35.4398 15.2948 32.0245C14.7812 31.4919 13.9321 31.4768 13.3996 31.9904C12.867 32.504 12.8519 33.3512 13.3655 33.8856C17.1674 37.8297 22.2789 40 27.7581 40C38.785 40 47.7572 31.0298 47.7572 20.001C47.7572 8.97261 38.787 0 27.7581 0C20.7549 0 14.4212 3.57449 10.7843 9.43451C10.7085 9.42124 10.6307 9.41177 10.5511 9.41177H5.25967C4.51864 9.41177 3.91972 10.0107 3.91972 10.7517C3.92351 11.4946 4.52243 12.0936 5.26346 12.0936L5.26281 12.0943Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M26.4214 34.2859C26.4214 35.0269 27.0204 35.6258 27.7614 35.6258C28.5005 35.6258 29.1013 35.0269 29.1013 34.2859V34.1248C29.1013 33.3857 28.5024 32.7849 27.7614 32.7849C27.0204 32.7849 26.4214 33.3838 26.4214 34.1248V34.2859Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M42.5278 21.3435C43.2669 21.3435 43.8677 20.7446 43.8677 20.0036C43.8677 19.2644 43.2688 18.6636 42.5278 18.6636H42.3667C41.6257 18.6636 41.0267 19.2625 41.0267 20.0036C41.0267 20.7427 41.6257 21.3435 42.3667 21.3435H42.5278Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M5.0469 29.205H6.49112C7.23215 29.205 7.83107 28.6061 7.83107 27.8651C7.83107 27.124 7.23215 26.5251 6.49112 26.5251H5.0469C4.30777 26.5251 3.70695 27.124 3.70695 27.8651C3.70695 28.6042 4.30777 29.205 5.0469 29.205Z",
      fill: color
    }, void 0)]
  }), void 0);
});